export default {
  'CustomerWithoutMovement.label.OSSituation': 'O.S. Situation',
  'CustomerWithoutMovement.label.type': 'Type',
  'CustomerWithoutMovement.label.moreOptions': 'More Options',

  'CustomerWithoutMovement.option.open': 'Open',
  'CustomerWithoutMovement.option.authorized': 'Authorized',
  'CustomerWithoutMovement.option.closed': 'Closed',
  'CustomerWithoutMovement.option.budget': 'Budget',
  'CustomerWithoutMovement.option.warranty': 'Warranty',
  'CustomerWithoutMovement.option.return': 'Return',
  'CustomerWithoutMovement.option.courtesy': 'Courtesy',
  'CustomerWithoutMovement.option.insideCourtesy': 'Inside (Courtesy)',
  'CustomerWithoutMovement.option.revision': 'Revision',

  'CustomerWithoutMovement.checkbox.inactiveCustomers':
    'Show inactive customers?',
};
